$('.base-aside-item-accordion-head').on('click', function (){
    $(this).toggleClass('active')
    $(this).next().slideToggle()
})

let next_url;
let fullContentLoaded = false;
const loadMoreContent = async (url) => {
    await $.ajax({
        type: 'GET',
        url: url,
        headers: {
            "x-localization": $('html').attr('lang'),
        }
    }).done(function (response) {
        $('.base-content').append(response.data.html)
        next_url = response.data.next_url
    }).fail(function (error) {
    });

    next_url
        ? $('.base-content-pagination').fadeIn('fast')
        : $('.base-content-pagination').fadeOut('fast')
};

$('.base-pagination').on('click', async function () {
    let baseUrl = $(this).attr('data-base-url')

    if (!next_url) {
        next_url = `${baseUrl}?page=2`
    }

    await loadMoreContent(next_url);

    if (!next_url) {

        fullContentLoaded = true
    }
})

$(document).ready(() => {
    const anchors = document.querySelectorAll('.base-aside-item a[href*="#"]')

    for (let anchor of anchors) {
        anchor.addEventListener('click',  async function (e) {
            e.preventDefault()

            const blockID = anchor.getAttribute('href').substr(1)

            let targetBlock = document.getElementById(blockID);

            if (!targetBlock && !fullContentLoaded) {
                const $loadMoreButton = $('.base-pagination')
                let baseUrl = $($loadMoreButton).attr('data-base-url')
                let first_url = `${baseUrl}?page=2`;

                if (!next_url) next_url = first_url;

                await loadMoreContent(`${next_url}&slug=${blockID}`);

                if (!next_url) {
                    fullContentLoaded = true
                }

                targetBlock = document.getElementById(blockID);
            }

            if (!targetBlock) {
                return
            }

            const offset = 114;

            const targetPosition = targetBlock.getBoundingClientRect().top + window.pageYOffset - offset;

            window.scrollTo({
                top: targetPosition,
                behavior: 'smooth'
            });
        })
    }
})


$('.base-content-toggler').on('click', function (){
    $('.base-aside').addClass('active')
    $('body').addClass('fixed-body')
})
$('.base-aside-head-close').on('click', function (){
    $('.base-aside').removeClass('active')
    $('body').removeClass('fixed-body')
})
